// extracted by mini-css-extract-plugin
export default {"homepage":"styles-module--homepage--cfcaf"};